import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FormViewParams } from '../models/state.model';
import { ViewParams } from '../../models/ViewParams';
import { FormContextValue } from '../../contexts/FormContext';

export interface SidebarViewParams extends FormViewParams {
  location: string;
  context?: FormContextValue;
}

type SidebarPayloadType = PayloadAction<SidebarViewParams>;

export type SidebarViewStack = Array<SidebarViewParams>;

const initialState: SidebarViewStack = [];

const SidebarViewsSlice = createSlice({
  name: 'sidebarViewStack',
  initialState,
  reducers: {
    openSidebar(state, action: SidebarPayloadType) {
      state.push(action.payload);
      return state;
    },

    setSidebarViewData(state, action: PayloadAction<ViewParams>) {
      if (state.length) {
        state[state.length - 1].dataRequest = action.payload;
      }

      return state;
    },

    setSidebarContext(state, action: PayloadAction<FormContextValue>) {
      if (state.length) {
        state[state.length - 1].context = action.payload;
      }

      return state;
    },

    closeSidebarView(state) {
      state.pop();
    },

    clearSidebarStack() {
      return initialState;
    },
  },
});

export const {
  openSidebar,
  setSidebarViewData,
  closeSidebarView,
  setSidebarContext,
  clearSidebarStack,
} = SidebarViewsSlice.actions;

const SidebarViewsStateReducer = SidebarViewsSlice.reducer;
export default SidebarViewsStateReducer;
